import React from 'react'
import PnDisplayPriceUi from './PnDisplayPriceUi'
import DisplayPriceBase from '../../catalog/rectangleResult/displays/DisplayPriceBase'

class PnDisplayPrice extends React.Component {
    render() {
        return (
            <DisplayPriceBase {...this.props} showPriceDiscountDisclaimer={false}>
                <PnDisplayPriceUi {...this.props}/>
            </DisplayPriceBase>
        )
    }
}

export default PnDisplayPrice
